// import Style from '../../../../../component/popup/style.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'

const AddPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, Style, buildings = [], meters = [] }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });

    useEffect(() => {
        console.log("currentData", currentData)
        if (currentData?.id) {
            formik.setFieldValue("assetName", currentData?.asset_name || "")
            formik.setFieldValue("category", currentData?.category_id ? Number(currentData?.category_id) : "")
            formik.setFieldValue("location_id", currentData?.location_id || "")
            formik.setFieldValue("vendor_id", currentData?.vendor_id || "")
            formik.setFieldValue("assetCode", currentData?.asset_code || "")
            formik.setFieldValue("brand", currentData?.brand || "")
            formik.setFieldValue("model", currentData?.model || "")
            formik.setFieldValue("purchase_date", currentData?.purchase_date ? moment(currentData?.purchase_date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("warranty_end", currentData?.warranty_end ? moment(currentData?.warranty_end, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("condition", currentData?.condition || "")
        }
    }, [currentData?.id])

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const validationSchema = yup.object().shape({
        assetName: yup.string().required('This Field is required'),
        category: yup.string().required('This Field is required'),
        location_id: yup.string().required('This Field is required'),
        vendor_id: yup.string().required('This Field is required'),
        assetCode: yup.string().required('This Field is required'),
        cost: yup.string().required('This Field is required'),
    });

    const formik = useFormik({
        initialValues: {
            assetName: "",
            category: "",
            location_id: "",
            vendor_id: "",
            assetCode: "",
            brand: "",
            model: "",
            purchase_date: "",
            warranty_end: "",
            condition: "",
            cost: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            console.log("Values", values);
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "id": currentData?.id
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "asset_name"  : values?.assetName,
                "category"    : values?.category,
                "location_id"  : values?.location_id,
                "vendor_id"    : values?.vendor_id,
                "asset_code"   : values?.assetCode,
                "brand": values?.brand,
                "model": values?.model,
                "purchase_date"  : values?.purchase_date,
                "warranty_end"   : values?.warranty_end,
                "condition"      : values?.condition,
                "purchase_cost": values?.cost
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `office-asset/update` : `office-asset/add`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Asset Name</FormLabel>
                            <input
                                type={'text'}
                                name={'assetName'}
                                onChange={formik.handleChange}
                                value={formik.values.assetName}
                                placeholder='Asset Name'
                            />
                            {formik.touched.assetName && formik.errors.assetName && (
                                <FeildError>{formik.errors.assetName}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Category</FormLabel>

                            <SelectSearch
                                name="category"
                                placeholder="- Select Category -"
                                onChange={(val) => {
                                    formik.setFieldValue("category", val);
                                }}
                                value={formik.values.category}
                                options={dropdowns?.asset_categories?.map((el) => ({
                                    label: el.value,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.category && formik.errors.category && (
                                <FeildError>{formik.errors.category}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Location</FormLabel>

                            <SelectSearch
                                name="location_id"
                                placeholder="- Select Location -"
                                onChange={(val) => {
                                    formik.setFieldValue("location_id", val);
                                }}
                                value={formik.values.location_id}
                                options={dropdowns?.asset_locations?.map((el) => ({
                                    label: el.value,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.location_id && formik.errors.location_id && (
                                <FeildError>{formik.errors.location_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Vendor</FormLabel>

                            <SelectSearch
                                name="vendor_id"
                                placeholder="- Select Vendor -"
                                onChange={(val) => {
                                    formik.setFieldValue("vendor_id", val);
                                }}
                                value={formik.values.vendor_id}
                                options={dropdowns?.asset_vendors?.map((el) => ({
                                    label: el.value,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.vendor_id && formik.errors.vendor_id && (
                                <FeildError>{formik.errors.vendor_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Asset Code</FormLabel>
                            <input
                                type={'text'}
                                name={'assetCode'}
                                onChange={formik.handleChange}
                                value={formik.values.assetCode}
                                placeholder='Asset Code'
                            />
                            {formik.touched.assetCode && formik.errors.assetCode && (
                                <FeildError>{formik.errors.assetCode}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Brand</FormLabel>
                            <input
                                type={'text'}
                                name={'brand'}
                                onChange={formik.handleChange}
                                value={formik.values.brand}
                                placeholder='Brand'
                            />
                            {formik.touched.brand && formik.errors.brand && (
                                <FeildError>{formik.errors.brand}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Cost</FormLabel>
                            <input
                                type={'number'}
                                name={'cost'}
                                onChange={formik.handleChange}
                                value={formik.values.cost}
                                placeholder='Cost'
                            />
                            {formik.touched.cost && formik.errors.cost && (
                                <FeildError>{formik.errors.cost}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Model</FormLabel>
                            <input
                                type={'text'}
                                name={'model'}
                                onChange={formik.handleChange}
                                value={formik.values.model}
                                placeholder='Model'
                            />
                            {formik.touched.model && formik.errors.model && (
                                <FeildError>{formik.errors.model}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Purchase Date</FormLabel>
                            
                            <input
                                type={'date'}
                                name={'purchase_date'}
                                onChange={formik.handleChange}
                                value={formik.values.purchase_date}
                                placeholder='Bill Receipt Number'
                            />
                            {formik.touched.purchase_date && formik.errors.purchase_date && (
                                <FeildError>{formik.errors.purchase_date}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Warranty End</FormLabel>
                            
                            <input
                                type={'date'}
                                name={'warranty_end'}
                                onChange={formik.handleChange}
                                value={formik.values.warranty_end}
                                placeholder='Bill Receipt Number'
                            />
                            {formik.touched.warranty_end && formik.errors.warranty_end && (
                                <FeildError>{formik.errors.warranty_end}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Condition</FormLabel>

                            <SelectSearch
                                menuPosition="fixed"
                                name="condition"
                                placeholder="- Select Condition -"
                                onChange={(val) => {
                                    formik.setFieldValue("condition", val);
                                }}
                                value={formik.values.condition}
                                options={dropdowns?.asset_condition?.map((el) => ({
                                    label: el,
                                    value: el,
                                }))}
                            />
                            {formik.touched.condition && formik.errors.condition && (
                                <FeildError>{formik.errors.condition}</FeildError>
                            )}
                        </FeildWraper>

                        {/* <FeildWraper>
                            <FormLabel required>Current Reading</FormLabel>
                            <input
                                type={'number'}
                                name={'currentReading'}
                                onChange={formik.handleChange}
                                value={formik.values.currentReading}
                                placeholder='Current Reading'
                            />
                            {formik.touched.currentReading && formik.errors.currentReading && (
                                <FeildError>{formik.errors.currentReading}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Previous Reading</FormLabel>
                            <input
                                type={'number'}
                                name={'previousReading'}
                                onChange={formik.handleChange}
                                value={formik.values.previousReading}
                                placeholder='Previous Reading'
                            />
                            {formik.touched.previousReading && formik.errors.previousReading && (
                                <FeildError>{formik.errors.previousReading}</FeildError>
                            )}
                        </FeildWraper> */}

                        {/* <FeildWraper>
                            <FormLabel required>Bill Amount</FormLabel>
                            
                            <input
                                type={'number'}
                                name={'bill_amount'}
                                onChange={formik.handleChange}
                                value={formik.values.bill_amount}
                                placeholder='Bill Amount'
                            />
                            {formik.touched.bill_amount && formik.errors.bill_amount && (
                                <FeildError>{formik.errors.bill_amount}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Bill Date</FormLabel>
                            
                            <input
                                type={'date'}
                                name={'billDate'}
                                onChange={formik.handleChange}
                                value={formik.values.billDate}
                                placeholder='Bill Receipt Number'
                            />
                            {formik.touched.billDate && formik.errors.billDate && (
                                <FeildError>{formik.errors.billDate}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Due Date</FormLabel>
                            
                            <input
                                type={'date'}
                                name={'dueDate'}
                                onChange={formik.handleChange}
                                value={formik.values.dueDate}
                                placeholder='Bill Receipt Number'
                            />
                            {formik.touched.dueDate && formik.errors.dueDate && (
                                <FeildError>{formik.errors.dueDate}</FeildError>
                            )}
                        </FeildWraper> */}

                        {/* <FeildWraper width='100%'>
                            <FormLabel>Notes</FormLabel>

                            <textarea
                                type={'text'}
                                name={'notes'}
                                onChange={formik.handleChange}
                                value={formik.values.notes}
                                placeholder='notes'
                            />
                            {formik.touched.notes && formik.errors.notes && (
                                <FeildError>{formik.errors.notes}</FeildError>
                            )}
                        </FeildWraper> */}

                        {/* <FeildWraper width='100%'>
                            <FormLabel>Bill Receipt</FormLabel>
                            
                            <FileUploadProgressBar
                                value={formik.values.billPath}
                                onChange={(file) => formik.setFieldValue("billPath", file)}
                                loader={formik.values.billPath}
                            // acceptType="pdf"
                            />
                            {
                                (formik.touched.billPath && Boolean(formik.errors.billPath)) && (
                                    <FeildError>{formik.touched.billPath && formik.errors.billPath}</FeildError>
                                )
                            }
                        </FeildWraper> */}
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    {
                        (formik?.values?.assignTo || (currentData?.id && currentData?.status == "Assigned" && formik?.values?.status != "Assigned")) ?
                            <p className='text-red-500 text-[14px]'>{formik?.values?.assignTo ? "If you enter an Assign to Date, the asset remains in stock, it gets assigned and then immediately unassigned from the selected user." : "This action will unassign all users from the asset."}</p>
                            :
                            null
                    }
                    {/* <div className={`${Style.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddPopup
